import { DepartmentResponse } from '@pixacare/dtos';
import { StoreDepartment } from '../models/store-department';
import { StoreDepartmentMembership } from '../models/store-department-membership';

export const storeDepartmentToDepartmentResponse = (
  storeDepartment: StoreDepartment | null,
): DepartmentResponse | null => {
  if (!storeDepartment) {
    return null;
  }
  const { labelPackIds, sadmClientIds, memberships, ...departmentResponse } = storeDepartment;
  return {
    ...departmentResponse,
    memberships: Object.values(memberships),
  };
};

export const departmentResponseToStoreDepartment = (dpt: DepartmentResponse): StoreDepartment => {
  const labelPackIds = dpt.labelPacks?.map((labelPack) => labelPack.id);
  const memberships = dpt.memberships?.reduce(
    (membershipAcc, membership) => ({
      ...membershipAcc,
      [membership.userId]: membership,
    }),
    {} as { [userId: number]: StoreDepartmentMembership },
  );

  const department = { ...dpt };
  delete department.labelPacks;

  return {
    ...department,
    labelPackIds,
    sadmClientIds: [],
    memberships,
    areMembershipsLoaded: false,
  };
};
